import React, { useContext, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import { getUniqueKpiList } from 'parser/PortfolioBubbleChartParsar';
import { bubbleChartElasticityComparisionParser } from 'parser/opportunityIdentificationParser/bubbleChartParser';
import { getOpportunityBubbleChart } from 'gqlQueries/opportunityIdentificationQueries';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';
function useFetchOpportunityBubbleChart() {
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [kpiListData, setKpiListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [group, setGroupBy] = useState('');
    const { appConfig } = useContext(UserContext);
    const portfolioAnalysisConfig = getConfig('portfolioAnalysis', appConfig);

    const [fetchOpportunityBubbleChart] = useLazyQuery(getOpportunityBubbleChart, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getOpportunityBubbleChart } = payload;
            //if data present parse it
            if (getOpportunityBubbleChart.length > 0) {
                setData(bubbleChartElasticityComparisionParser(getOpportunityBubbleChart, group));
                const uniqueKpiList: any = getUniqueKpiList(getOpportunityBubbleChart, portfolioAnalysisConfig);
                setKpiListData(uniqueKpiList);
                setError(null);
                return;
            }
            setData(null);
        } catch (error: any) {
            setData(null);
            setError(error);
            console.error(errorMessage, error, 'logging error');
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        error,
        data,
        loading,
        kpiListData,
        fetchOpportunityBubbleChart: (variables: any) => {
            setLoading(true);
            setGroupBy(variables.variables.groupBy);
            fetchOpportunityBubbleChart(variables);
        },
    };
}

export { useFetchOpportunityBubbleChart };
